/**
 * Copyright (c) 2025 Kalpit Patel
 *
 * Sole Developer and Owner:
 * Kalpit Patel is the sole developer and creator of this entire application.
 * No other individual or entity has contributed to the development of this software.
 * All rights reserved.
 *
 * This file is part of AksharJobs application.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/button-system.css'; // Import consistent button sizing system
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/urlInterceptor'; // Import URL interceptor to fix hardcoded URLs

// Suppress proxy errors from browser extensions
window.addEventListener('error', (event) => {
  if (event.message && (
    event.message.includes('Attempting to use a disconnected port object') ||
    event.message.includes('WebSocket connection error') ||
    event.message.includes('Socket.IO not configured')
  )) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Suppress unhandled promise rejections from proxy errors
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('Attempting to use a disconnected port object') ||
    event.reason.message.includes('WebSocket connection error') ||
    event.reason.message.includes('Socket.IO not configured')
  )) {
    event.preventDefault();
    return false;
  }
});

// Some imported static HTML (or browser extensions) reference a global editSection.
// Define a harmless noop to avoid console errors when it's missing.
if (typeof window !== 'undefined' && typeof window.editSection !== 'function') {
  window.editSection = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
